// extracted by mini-css-extract-plugin
module.exports = {"content":"ErrorGate_content__1VJLy","wrapper":"ErrorGate_wrapper__3JXoi"};